import RestService from '@services/RestService';

const MediaService = {
  async getMainMediaList() {
    try {
      const res = await new RestService().setPath('/media/displayed').get();
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
  async getMediaListAll(params = {}) {
    try {
      const res = await new RestService()
        .setPath('/media/list-client')
        .setConfig({ params })
        .get();
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  }
};

export default MediaService;
